module.exports = __webpack_public_path__ + "img/1.03d9baa7.png";